import axios from 'axios'
import Conf from 'ui-config'
const ClusterService = {
  uistate: function() {
    return axios.get(Conf.HOST + Conf.LC_IP + '/lc/state')
  },

  licenseFlag: function(params, ssid) {
    return axios.post(Conf.HOST + Conf.LC_IP + '/lc/mgmt/cluster/license_flag', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  getTenantList: function(ssid, body) {
    return axios(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/tenant-list', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
      data: body,
    })
  },
  getClustersList: function(ssid, params) {
    var page = params && params.page ? '?page=' + params.page + '&size=' + params.size : ''
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/list' + page, {
      headers: {
        SSID: ssid,
      },
    })
  },
  getClusterDetail: function(ssid, cluster_id) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/' + cluster_id, {
      headers: {
        SSID: ssid,
      },
    })
  },

  getSummaryDetail: async function(params) {
    return await axios.get(
      Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/' + params.cluster_id + '/summary_details',
      {
        headers: {
          SSID: params.ssid,
        },
      },
    )
  },
  connectToCore: function(params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/connect', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  clusterSetup: function(params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/setup', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  editClusterName: function(params, clusterId, ssid) {
    return axios.put(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/' + clusterId, params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  validateLicense: function(cluster_id, params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/' + cluster_id + '/mgmt/license/fetch', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  acceptEULA: function(params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/cluster/eula', params, {
      headers: {
        SSID: ssid,
      },
    })
  },
  LC_IP: Conf.LC_IP,

  //Stream Config

  getStreamConfig: function(clusterId, ssid) {
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/core/stream-config', {
      headers: {
        SSID: ssid,
      },
    })
  },

  putStreamConfig: function(params, clusterId, ssid) {
    return axios.put(
      Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/core/stream-config',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  getScopeStreamConfig: function(clusterId, scopeId, ssid) {
    return axios.get(
      Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/scope/' + scopeId + '/stream-config',
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  putScopeStreamConfig: function(params, clusterId, scopeId, ssid) {
    return axios.put(
      Conf.HOST_S + Conf.LC_IP + '/' + clusterId + '/mgmt/scope/' + scopeId + '/stream-config',
      params,
      {
        headers: {
          SSID: ssid,
        },
      },
    )
  },

  //Audit Trail

  clusterAudit: function(params, ssid, clusterId) {
    let queryParams = `${Conf.HOST_S}${Conf.LC_IP}/${clusterId}/mgmt/core/audit-trail?start=${params.from}&end=${params.to}`
    if (params.export) {
      queryParams = queryParams + '&export=true'
    }

    return axios.get(queryParams, {
      headers: {
        SSID: ssid,
      },
      params: params,
    })
  },
  consoleAudit: function(params, ssid) {
    let queryParams =
      '?from=' +
      params.from +
      '&to=' +
      params.to +
      '&pageno=' +
      params.pageno +
      '&pagesize=' +
      params.pagesize
    if (params.orgId) {
      queryParams = queryParams + '&orgId=' + params.orgId
    }
    if (params.export) {
      queryParams = queryParams + '&export=true'
    }
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/audit-trail/' + queryParams, {
      headers: {
        SSID: ssid,
      },
      // params: params,
    })
  },
  tenantOpsAudit: function(params, ssid) {
    let queryParams =
      '?from=' +
      params.from +
      '&to=' +
      params.to +
      '&pageno=' +
      params.pageno +
      '&pagesize=' +
      params.pagesize
    if (params.tenantListFlag) {
      queryParams = queryParams + '&tenant-list=True'
    } else {
      queryParams = queryParams + '&tenant-list=False'
    }
    if (params.export) {
      queryParams = queryParams + '&export=true'
    }
    return axios.get(Conf.HOST_S + Conf.LC_IP + '/lc/mgmt/audit-trail/' + queryParams, {
      headers: {
        SSID: ssid,
      },
      // params: params,
    })
  },
  acceptPrivacyPolicy: function(params, ssid) {
    return axios.post(Conf.HOST_S + Conf.LC_IP + `/lc/mgmt/${params.user_id}`, params.user_id, {
      headers: {
        SSID: ssid,
      },
    })
  },
  // Root override of the cluster's customer code; a null code clears the override so
  // Core's value is used again. Resolves to { data } on success, or to
  // { error: 'invalid_code' | 'forbidden' | 'not_found' | 'session_expired' | 'failed', message }.
  // The caller handles session_expired (Common imports this module, so it can't be used here).
  updateCustomerCode: async function(ssid, clusterId, customerCode) {
    const body =
      customerCode === null ? { customerCode: null, clear: true } : { customerCode: customerCode }
    const toError = function(status, data) {
      data = data || {}
      if (status === 401 || data.status === 'invalid') {
        return { error: 'session_expired' }
      }
      let error = 'failed'
      if (status === 404) error = 'not_found'
      else if (data.message === 'user not authorized') error = 'forbidden'
      else if (data.message === 'invalid customer code') error = 'invalid_code'
      return { error: error, message: data.message }
    }
    try {
      const response = await axios.put(
        Conf.HOST_S +
          Conf.LC_IP +
          '/lc/mgmt/cluster/' +
          encodeURIComponent(clusterId) +
          '/customer-code',
        body,
        {
          headers: {
            SSID: ssid,
          },
        },
      )
      if (response.data && response.data.status === 'success') {
        return { data: response.data.data }
      }
      return toError(response.status, response.data)
    } catch (err) {
      const res = err && err.response
      return toError(res && res.status, res && res.data)
    }
  },
}

export default ClusterService
